var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntelWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 88,
    viewBox: "0 0 120 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.006 6.36822C100.605 5.42404 98.4507 5.58475 97.2141 6.68964L89.2271 13.8112C87.9801 14.9362 88.0832 16.6538 89.4435 17.6181C89.4435 17.6181 101.759 26.4171 101.759 45.3409C101.759 64.2648 88.7943 73.6062 88.7943 73.6062C87.4751 74.6609 87.4339 76.4287 88.6809 77.5437L96.5957 84.5547C97.8324 85.6596 100.007 85.8203 101.408 84.8862C101.408 84.8862 120 72.5716 120 45.4113C120 18.2509 102.017 6.38831 102.017 6.38831",
    fill: "#FF3D00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0636 50.6846C25.0636 50.6846 22.7551 50.4737 22.7551 52.2717C22.7551 62.5271 30.608 69.8194 42.9131 69.8194C52.0646 69.8194 55.9705 67.7 61.5047 63.6621C62.7929 62.718 64.1532 61.8441 65.2147 62.949C65.9361 63.7124 75.6441 72.441 75.6441 72.441C76.8602 73.5459 76.5304 74.8718 75.2216 75.9466C73.9334 77.0113 59.4229 88 42.7482 88C20.9207 88 0 78.749 0 43.9146C0 15.8502 16.3243 0 40.2542 0C65.9773 0 80.5187 17.4975 80.5187 41.1022V47.0786C80.5187 49.5094 78.4885 50.6947 76.819 50.6947H25.0636V50.6846ZM55.6922 26.7485C53.2291 21.6359 48.0763 17.829 40.2748 17.829C32.4734 17.829 27.3411 21.6359 24.8471 26.7485C23.4146 29.8824 22.889 32.2027 22.7139 35.9895H57.8358C57.6606 32.2027 57.1144 29.8925 55.7025 26.7485",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntelWhite);
export default __webpack_public_path__ + "static/media/entel-white.ec81a9b59df9c36b81277c67cbd96cbb.svg";
export { ForwardRef as ReactComponent };